<template>
  <!-- eslint-disable vue/no-lone-template -->
  <div class="package-editor">
    <div class="row">
      <div class="col image-container">
        <label class="label">รูปปก</label>
        <img :src="modalImageUrl" class="image" />
        <sc-button
          v-if="!disabled"
          class="thumbnail-button"
          @click="handleClickChooseImageButton"
          >เลือกรูปปก</sc-button
        >
        <br />
        <label class="label">รูป Thumbnail</label>
        <img :src="modalThumbnailUrl" class="thumbnail" />
        <sc-button
          v-if="!disabled"
          class="thumbnail-button"
          @click="handleClickChooseThumbnailButton"
          >เลือกรูป Thumbnail</sc-button
        >
      </div>
      <div class="col info-editor">
        <label v-if="id" class="label">ชื่อ (ID: {{ id }})</label>
        <label v-else class="label">ชื่อ</label>
        <el-input
          :value="name"
          :disabled="disabled"
          class="input"
          @input="handleChangeInput('name', $event)"
        ></el-input>
        <label class="label">ชื่อที่แสดงในใบเสร็จ/ใบกำกับภาษี</label>
        <el-input
          :value="receiptName"
          :disabled="disabled"
          class="input"
          @input="handleChangeInput('receiptName', $event)"
        ></el-input>
        <div>
          <label class="label">อายุการใช้งานของแพ็กเกจ</label>
          <el-checkbox v-model="isTemporaryPackage">
            แพ็กเกจนี้สามารถสมัครหรือต่ออายุได้จนถึงวันที่
            <date-picker
              v-model="expiredDate"
              :disabled="!isTemporaryPackage"
              class="input"
              type="date"
            ></date-picker>
          </el-checkbox>
        </div>
        <el-checkbox v-model="hasDiscountPromotion"
          >จัดโปรโมชั่นลดราคา</el-checkbox
        >
        <template v-if="!hasDiscountPromotion">
          <label class="label">ราคา (บาท)</label>
          <el-input
            :disabled="disabled"
            :value="price"
            class="input"
            type="number"
            min="0"
            @input="handleChangeInput('price', $event)"
          ></el-input>
        </template>
        <template v-else>
          <label class="label">ราคาเต็ม (บาท)</label>
          <el-input
            v-model="originalPrice"
            :disabled="disabled"
            class="input"
            type="number"
          ></el-input>
          <label class="label"
            >ลดแล้วเหลือ (บาท) -
            <small
              >ระบบจะทำการ<strong>ตัดเงิน</strong>ลูกค้าจากยอดนี้</small
            ></label
          >
          <el-input
            :disabled="disabled"
            :value="price"
            class="input"
            type="number"
            min="0"
            @input="handleChangeInput('price', $event)"
          ></el-input>
        </template>
        <label class="label">รอบตัดบิล (จำนวนเดือน)</label>
        <el-input
          :disabled="disabled"
          :value="billingCycle"
          class="input"
          type="number"
          min="0"
          @input="handleChangeInput('billingCycle', $event)"
        ></el-input>
        <label class="label">เหมาะสำหรับ</label>
        <el-select
          :value="targetId"
          :disabled="disabled"
          class="input target-select"
          @change="handleChangeTarget"
        >
          <el-option
            v-for="option in targets"
            :key="option.id"
            :value="option.id"
            :label="option.name"
          ></el-option>
        </el-select>
        <div>
          <label class="label">จำกัดสิทธิ์การซื้อ</label>
          <el-select
            v-model="purchasingLimit"
            class="input"
            placeholder="ไม่จำกัดสิทธิ์"
            clearable
          >
            <el-option
              v-for="option in purchasingLimitOptions"
              :key="option.value"
              :value="option.value"
              :label="option.label"
              >{{ option.label }}</el-option
            >
          </el-select>
        </div>
        <label class="label">อื่น ๆ</label>
        <div>
          <el-checkbox v-model="hasRegistrationForm"
            >มี Registration Form</el-checkbox
          >
        </div>
        <div>
          <el-checkbox v-model="hasNoteLabel">มีหัวข้อหมายเหตุ</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="hasPurchaseSuccessTitle"
            >มีหัวข้อการสั่งซื้อสำเร็จ</el-checkbox
          >
        </div>
        <div>
          <el-checkbox v-model="hasPurchaseSuccessMessage"
            >มีข้อความหลังการสั่งซื้อสำเร็จ</el-checkbox
          >
        </div>
        <div v-show="hasNoteLabel">
          <label class="label">หัวข้อหมายเหตุ</label>
          <el-input
            :value="noteLabel"
            :disabled="disabled"
            class="input"
            @input="handleChangeInput('noteLabel', $event)"
          ></el-input>
        </div>
        <label class="label">รายละเอียด</label>
        <el-input
          :value="detail"
          :disabled="disabled"
          class="input"
          type="textarea"
          rows="7"
          @input="handleChangeInput('detail', $event)"
        ></el-input>
        <label class="label">เงื่อนไขการใช้บริการ</label>
        <el-input
          :value="termsAndConditions"
          :disabled="disabled"
          class="input"
          type="textarea"
          rows="7"
          @input="handleChangeInput('termsAndConditions', $event)"
        ></el-input>
        <template v-if="hasRegistrationForm">
          <label class="label mb-2">ข้อมูลเพิ่มเติม</label>
          <package-extra-editor
            v-model="registrationForm"
          ></package-extra-editor>
        </template>
        <div v-show="hasPurchaseSuccessTitle">
          <label class="label">หัวข้อการสั่งซื้อสำเร็จ</label>
          <el-input
            v-model="purchaseSuccessTitle"
            :disabled="disabled"
            class="input"
          ></el-input>
        </div>
        <div v-show="hasPurchaseSuccessMessage">
          <label class="label">ข้อความหลังการสั่งซื้อสำเร็จ</label>
          <el-input
            v-model="purchaseSuccessMessage"
            :disabled="disabled"
            class="input"
            type="textarea"
            rows="7"
          ></el-input>
        </div>
        <div>
          <label class="label">ผู้จัดหาบริการ</label>
          <el-select
            v-model="sellerTradePartyId"
            class="input sellerTradeParty"
            placeholder="เลือกผู้จัดหาบริการ"
          >
            <el-option
              v-for="option in sellerTradePartyOptions"
              :key="option.value"
              :value="option.value"
              :label="option.label"
              >{{ option.label }}</el-option
            >
          </el-select>
        </div>
        <label class="label">รายการบริการ</label>
        <service-selector
          :value="services"
          :disabled="disabled"
          class="input"
          @input="handleChangeInput('services', $event)"
        ></service-selector>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
    <image-picker-modal
      v-bind="chooseThumbnailDialog"
      @cancel="handleCancelChooseThumbnailDialog"
      @confirm="handleConfirmChooseThumbnailDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input, Select, Option, Checkbox } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import ImagePickerModal from "@/lib/components/ImagePickerModal"
import ServiceSelector from "@/lib/components/ServiceSelector/ServiceSelector"
import DatePicker from "@/lib/components/DatePicker"
import { isNil } from "ramda"
import { DateTime } from "luxon"
import PackageExtraEditor from "./PackageExtraEditor"

export default {
  components: {
    ScButton,
    ImagePickerModal,
    ServiceSelector,
    PackageExtraEditor,
    DatePicker,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
  },
  props: {
    value: { type: Object, required: true },
    imageUrl: { type: String, default: null },
    thumbnailUrl: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    targets: { type: Array, default: () => [] },
    sellerTradeParties: { type: Array, default: () => [] },
  },
  data() {
    const cache = {
      originalPrice: this.value.originalPrice,
      expiredAt: this.value.expiredAt,
    }

    const purchasingLimitOptions = [
      { value: "PER_HOME", label: "บ้านละครั้ง" },
      { value: "PER_USER", label: "คนละครั้ง" },
    ]

    return {
      isShowModal: false,
      isShowThumbnailModal: false,
      purchasingLimitOptions,
      cache,
    }
  },
  computed: {
    hasDiscountPromotion: {
      get() {
        return typeof this.value.originalPrice === "number"
      },
      set(hasDiscountPromotion) {
        if (hasDiscountPromotion) {
          this.$emit("input", {
            ...this.value,
            originalPrice: this.cache.originalPrice || 0,
          })
          return
        }

        this.$emit("input", {
          ...this.value,
          originalPrice: this.cache.originalPrice,
        })
      },
    },
    originalPrice: {
      get() {
        return this.value.originalPrice
      },
      set(value) {
        return this.$emit("input", { ...this.value, originalPrice: +value })
      },
    },
    isTemporaryPackage: {
      get() {
        return !isNil(this.value.expiredAt)
      },
      set(isTemporaryPackage) {
        if (isTemporaryPackage) {
          this.$emit("input", {
            ...this.value,
            expiredAt:
              this.cache.expiredAt ||
              DateTime.utc().setZone("utc+7").endOf("day"),
          })
        } else {
          this.$emit("input", {
            ...this.value,
            expiredAt: null,
          })
        }
      },
    },
    expiredDate: {
      get() {
        if (isNil(this.value.expiredAt)) return null

        return this.value.expiredAt.setZone("utc+7").startOf("day")
      },
      set(expiredDate) {
        if (!expiredDate) return
        this.$emit("input", {
          ...this.value,
          expiredAt: expiredDate.setZone("utc+7").endOf("day"),
        })
      },
    },
    hasNoteLabel: {
      get() {
        return !isNil(this.value.noteLabel)
      },
      set(hasNoteLabel) {
        const noteLabel = hasNoteLabel ? "" : null

        this.$emit("input", {
          ...this.value,
          noteLabel,
        })
      },
    },
    hasPurchaseSuccessTitle: {
      get() {
        return !isNil(this.value.purchaseSuccessTitle)
      },
      set(hasPurchaseSuccessTitle) {
        const purchaseSuccessTitle = hasPurchaseSuccessTitle ? "" : null

        this.$emit("input", {
          ...this.value,
          purchaseSuccessTitle,
        })
      },
    },
    hasPurchaseSuccessMessage: {
      get() {
        return !isNil(this.value.purchaseSuccessMessage)
      },
      set(hasPurchaseSuccessMessage) {
        const purchaseSuccessMessage = hasPurchaseSuccessMessage ? "" : null

        this.$emit("input", {
          ...this.value,
          purchaseSuccessMessage,
        })
      },
    },
    purchaseSuccessTitle: {
      get() {
        return this.value.purchaseSuccessTitle
      },
      set(purchaseSuccessTitle) {
        this.$emit("input", { ...this.value, purchaseSuccessTitle })
      },
    },
    purchaseSuccessMessage: {
      get() {
        return this.value.purchaseSuccessMessage || ""
      },
      set(purchaseSuccessMessage) {
        this.$emit("input", { ...this.value, purchaseSuccessMessage })
      },
    },
    hasRegistrationForm: {
      get() {
        return this.value.hasRegistrationForm
      },
      set(hasRegistrationForm) {
        this.$emit("input", {
          ...this.value,
          hasRegistrationForm,
          registrationForm: hasRegistrationForm
            ? {
                title: "",
                sections: [],
              }
            : null,
        })
      },
    },
    registrationForm: {
      get() {
        return this.value.registrationForm
      },
      set(registrationForm) {
        return this.$emit("input", { ...this.value, registrationForm })
      },
    },
    purchasingLimit: {
      get() {
        return this.value.purchasingLimit
      },
      set(purchasingLimit) {
        if (purchasingLimit === "") {
          return this.$emit("input", { ...this.value, purchasingLimit: null })
        }

        return this.$emit("input", { ...this.value, purchasingLimit })
      },
    },
    sellerTradePartyId: {
      get() {
        return this.value.sellerTradePartyId
      },
      set(sellerTradePartyId) {
        return this.$emit("input", { ...this.value, sellerTradePartyId })
      },
    },
    id() {
      return this.value.id
    },
    name() {
      return this.value.name
    },
    receiptName() {
      return this.value.receiptName
    },
    detail() {
      return this.value.detail
    },
    price() {
      return this.value.price
    },
    billingCycle() {
      return this.value.billingCycle
    },
    termsAndConditions() {
      return this.value.termsAndConditions
    },
    services() {
      return this.value.services
    },
    noteLabel() {
      return this.value.noteLabel
    },
    modalThumbnailUrl() {
      if (!this.chooseThumbnailDialog.thumbnailUrl) {
        return "https://placehold.co/200x200"
      }

      return this.chooseThumbnailDialog.thumbnailUrl
    },
    modalImageUrl() {
      if (!this.chooseImageDialog.thumbnailUrl) {
        return "https://placehold.co/1200x800"
      }

      return this.chooseImageDialog.thumbnailUrl
    },
    targetId() {
      if (!this.value.target) {
        return null
      }

      return this.value.target.id
    },
    sellerTradePartyOptions() {
      const sellerTradePartyOptions = this.sellerTradeParties.map((seller) => ({
        value: seller.id,
        label: seller.name,
      }))

      return sellerTradePartyOptions
    },
    chooseImageDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูปปกแพ็กเกจ",
        width: 300,
        height: 200,
        recommendWidth: 1200,
        recommendHeight: 800,
        thumbnailFile: this.value.imageFile,
        thumbnailUrl: this.imageUrl,
      }
    },
    chooseThumbnailDialog() {
      return {
        isShow: this.isShowThumbnailModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Thumbnail แพ็กเกจ",
        width: 200,
        height: 200,
        recommendWidth: 200,
        recommendHeight: 200,
        thumbnailFile: this.value.thumbnailFile,
        thumbnailUrl: this.thumbnailUrl,
      }
    },
  },
  methods: {
    handleChangeInput(key, value) {
      const isNumber = key === "price" || key === "billingCycle"
      this.$emit("input", { ...this.value, [key]: isNumber ? +value : value })
    },
    handleClickChooseImageButton() {
      this.isShowModal = true
    },
    handleClickChooseThumbnailButton() {
      this.isShowThumbnailModal = true
    },
    handleCancelChooseImageDialog() {
      this.isShowModal = false
    },
    handleCancelChooseThumbnailDialog() {
      this.isShowThumbnailModal = false
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, imageFile: file })
      this.isShowModal = false
    },
    handleConfirmChooseThumbnailDialog(file) {
      this.$emit("input", { ...this.value, thumbnailFile: file })
      this.isShowThumbnailModal = false
    },
    handleChangeTarget(targetId) {
      const target = this.targets.find((t) => t.id === targetId) ?? null

      this.$emit("input", { ...this.value, target })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-editor {
  max-width: calc(100% - 225px);
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }

  &.sellerTradeParty {
    width: 350px;
  }
}

.select {
  margin-bottom: 20px;
}

.input > textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}

.btn-action {
  margin-top: 30px;
}
</style>
